import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Envelope } from "@phosphor-icons/react";
import { api } from "../lib/api";
import { toast } from "sonner";
import BuzzLogo from "../components/BuzzLogo";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot", { email });
      setSent(true);
    } catch (err) {
      // Server always returns 200 to prevent enumeration — this catch is defensive
      setSent(true);
    }
    setBusy(false);
  };

  return (
    <div className="min-h-screen bg-[#F7F6F2] flex items-center justify-center px-6 font-body">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-2 mb-8">
          <div className="w-8 h-8 rounded-lg bg-[#0E1512] flex items-center justify-center"><BuzzLogo size={20} /></div>
          <span className="font-heading font-extrabold">BuzzerAI</span>
        </Link>
        <div className="text-[11px] tracking-[0.28em] uppercase text-[#D96C5B] font-semibold mb-2">Reset password</div>
        <h1 className="font-heading text-4xl md:text-5xl text-[#0E1512] tracking-tight leading-none mb-3">Forgot it? No worries.</h1>
        <p className="text-sm text-[#5C6B61] mb-8">Enter the email you signed up with. We'll send you a link to set a new password.</p>

        {sent ? (
          <div className="paper-card p-6" data-testid="forgot-sent">
            <Envelope size={32} weight="fill" color="#1E3A2F" />
            <h2 className="font-heading text-xl font-extrabold mt-3 mb-2">Check your inbox.</h2>
            <p className="text-sm text-[#5C6B61] leading-relaxed">
              If <b>{email}</b> is a real account, we just sent a reset link there. The link is good for 1 hour. If you don't see it in a few minutes, check spam or try again.
            </p>
            <Link to="/login" className="inline-block mt-4 text-sm text-[#0E1512] font-semibold underline decoration-[#F5C543] decoration-2 underline-offset-4">
              Back to log in
            </Link>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
            <div>
              <label className="overline block mb-1.5">Email</label>
              <input
                data-testid="forgot-email"
                className="input-field"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <button
              data-testid="forgot-submit"
              disabled={busy || !email}
              className="w-full inline-flex items-center justify-center gap-2 bg-[#0E1512] text-white text-sm font-bold px-6 py-3.5 rounded-full hover:bg-[#1E3A2F] transition-all disabled:opacity-60"
            >
              {busy ? "Sending…" : "Send reset link"} <ArrowRight size={16} weight="bold" />
            </button>
            <p className="text-sm text-[#5C6B61] mt-3">
              Remembered it? <Link to="/login" className="text-[#121914] font-semibold underline decoration-[#F5C543] decoration-2 underline-offset-4">Back to log in</Link>
            </p>
          </form>
        )}
      </div>
    </div>
  );
}
